module.exports = __webpack_public_path__ + "img/empty1.6f9fb57c.png";